import { apiRequest } from "../api/apiClient";
import { Address } from "../types/slice.types";

const ROUTE_PREFIX = "auth/address";

const addUserAddress = async (address: Address) => {
  const { data, error } = await apiRequest(
    "post",
    `/${ROUTE_PREFIX}/add-address`,
    { address }
  );

  return { data, error };
};

const updateUserAddress = async (address: Address) => {
  const { data, error } = await apiRequest(
    "patch",
    `/${ROUTE_PREFIX}/update-address/${address._id}`,
    { address }
  );
  return { data, error };
};

const deleteUserAddress = async (addressId: string) => {
  const { data, error } = await apiRequest(
    "delete",
    `/${ROUTE_PREFIX}/delete-address/${addressId}`
  );
  return { data, error };
};

export { addUserAddress, updateUserAddress, deleteUserAddress };
